import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../auth/AuthProvider";
import { Link } from "react-router-dom";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import "./style/Themes.css";
export default function Themes() {
  const availableThemes = [
    "love-and-disappointment",
    "stress-and-fatigue",
    "motivation-and-procrastination",
  ];

  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [themeProgress, setThemeProgress] = useState({});

  const { user, googleUser, setRedirection, apiUrl, setError } =
    useContext(AuthContext);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        // 1️⃣ Get all themes
        const themeRes = await axios.get(`${apiUrl}/theme`);
        const sortedThemes = themeRes.data.sort((a, b) => a.id - b.id);
        setThemes(sortedThemes);

        // 2️⃣ If not logged in → stop here
        if (!user && !googleUser) return;

        const identifier = user?.username || googleUser?.email;
        const isGoogle = !!googleUser;

        const themeEndpoint = isGoogle
          ? "byGoogleUserAndTheme"
          : "byUserAndTheme";

        const infoEndpoint = isGoogle ? "byGoogleUserInfo" : "byUserInfo";

        const progressData = {};

        // 3️⃣ Fetch progress dynamically for each theme
        for (const t of sortedThemes) {
          try {
            // Get latest question progress
            const progressRes = await axios.get(
              `${apiUrl}/user-question/${themeEndpoint}/${identifier}/${t.slug}`,
            );

            const sorted = progressRes.data.sort(
              (a, b) => b.questionId - a.questionId,
            );

            const lastIndex = sorted[0]?.questionThemeIndex || 0;

            // Check if theme completed (Phase 5 Question 5_5)
            const completionRes = await axios.get(
              `${apiUrl}/user-question/${infoEndpoint}/${identifier}/${t.slug}/Phase 5`,
            );

            const completed = completionRes.data.some(
              (q) =>
                q.questionIndex === 5 &&
                q.phaseName === "Phase 5" &&
                q.questionNumber === "Question 5_5",
            );

            progressData[t.slug] = {
              progress: lastIndex,
              completed,
            };
          } catch (err) {
            // If one theme fails, don't break everything
            progressData[t.slug] = {
              progress: 0,
              completed: false,
            };
          }
        }

        setThemeProgress(progressData);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [user, googleUser, apiUrl]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div id="relifeClassChild">
      {themes.map((t) => {
        const isAvailable = availableThemes.includes(t.slug);

        const progressInfo = themeProgress[t.slug] || {};
        const progressPercent = progressInfo.progress
          ? Math.floor((progressInfo.progress / 25) * 100)
          : 0;

        if (!isAvailable) {
          return (
            <Link
              key={t.id}
              className="linkTagTheme disabledLinkTagTheme"
              style={{
                position: "relative",
                pointerEvents: "none",
                opacity: 0.6,
              }}
            >
              <img src={t.image} alt={t.title} width={200} height={200} />
              <h2
                className="cardTitle"
                // id="cardTitle1"
                id="ct"
                style={{ fontSize: "2rem" }}
              >
                {t.title}
              </h2>
              <p className="cardDesc" id="cardDesc">
                {t.description}
              </p>
              <hr />
              <p className="soon">COMING SOON</p>
            </Link>
          );
        }

        return (
          <a
            key={t.id}
            href={`/session/${t.slug}`}
            className="linkTagTheme"
            onClick={() => setRedirection(`/session/${t.slug}`)}
          >
            {progressInfo.completed ? (
              <p
                style={{ color: "green" }}
                className="available"
                id="available"
              >
                Completed
              </p>
            ) : (
              ""
            )}
            <img
              src={t.image}
              alt={t.title}
              width={200}
              height={200}
              className="cardImg"
            />
            <div style={{ color: "gray" }} className="phaseSectionParagraph">
              <div className="progressLineParent" id="progressLineParent">
                {progressPercent && progressPercent !== 0 ? (
                  <div
                    className="progressLineChild"
                    id="progressLineChild"
                    style={{
                      backgroundColor:
                        progressInfo.progress === 25 ? "green" : "",
                      width:
                        Math.floor((progressInfo.progress / 25) * 100) + "%",
                    }}
                  ></div>
                ) : (
                  <div
                    className="progressLineChild"
                    style={{ width: "0" }}
                  ></div>
                )}
              </div>
            </div>
            <h2 className="cardTitle ct" id="ct" style={{ fontSize: "1.7rem" }}>
              {t.title}
            </h2>

            <p className="cardDesc" id="cardDesc">
              {t.description}
            </p>

            <hr className="cardLine" />

            <p className="cardDuration" id="cardDuration">
              {progressPercent === 0 ? "BEGIN THEME →" : "CONTINUE →"}
            </p>
          </a>
        );
      })}
    </div>
  );
}

// import axios from "axios";
// import { useContext, useEffect, useState } from "react";
// import { AuthContext } from "../auth/AuthProvider";
// import { Link } from "react-router-dom";
// import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

// export default function Themes() {
//   const [theme, setTheme] = useState([]);
//   // const [error, setError] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [themeCompleteLoveDisappointment, setThemeCompleteLoveDisappointment] =
//     useState(null);
//   const [themeCompleteStressFatigue, setThemeCompleteStressFatigue] =
//     useState(null);

//   const {
//     user,
//     googleUser,
//     prevLocation,
//     setRedirection,
//     phase5Complete,
//     setPhase5Complete,
//     themeCompletion,
//     setThemeCompletion,
//     themeCompletion1,
//     setThemeCompletion1,
//     apiUrl,
//     error,
//     setError,
//     // setLoading,
//   } = useContext(AuthContext);

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setLoading(true);

//         // 1️⃣ Get themes
//         const themeRes = await axios.get(`${apiUrl}/theme`);
//         setTheme(themeRes.data.sort((a, b) => a.id - b.id));

//         // 2️⃣ If no logged user → stop
//         if (!user && !googleUser) return;

//         const identifier = user?.username || googleUser?.email;
//         const isGoogle = !!googleUser;

//         const themeEndpoint = isGoogle
//           ? "byGoogleUserAndTheme"
//           : "byUserAndTheme";

//         const infoEndpoint = isGoogle ? "byGoogleUserInfo" : "byUserInfo";

//         // 3️⃣ Love & Disappointment progress
//         const loveRes = await axios.get(
//           `${apiUrl}/user-question/${themeEndpoint}/${identifier}/love-and-disappointment`,
//         );

//         const loveSorted = loveRes.data.sort(
//           (a, b) => b.questionId - a.questionId,
//         );

//         setThemeCompletion(loveSorted[0]?.questionThemeIndex);

//         // 4️⃣ Stress & Fatigue progress
//         const stressRes = await axios.get(
//           `${apiUrl}/user-question/${themeEndpoint}/${identifier}/stress-and-fatigue`,
//         );

//         const stressSorted = stressRes.data.sort(
//           (a, b) => b.questionId - a.questionId,
//         );

//         setThemeCompletion1(stressSorted[0]?.questionThemeIndex);

//         // 5️⃣ Phase 5 completion check (Love)
//         const phaseLoveRes = await axios.get(
//           `${apiUrl}/user-question/${infoEndpoint}/${identifier}/love-and-disappointment/Phase 5`,
//         );

//         const loveCompleted = phaseLoveRes.data.some(
//           (q) =>
//             q.questionIndex === 5 &&
//             q.phaseName === "Phase 5" &&
//             q.questionNumber === "Question 5_5",
//         );

//         setThemeCompleteLoveDisappointment(loveCompleted);

//         // 6️⃣ Phase 5 completion check (Stress)
//         const phaseStressRes = await axios.get(
//           `${apiUrl}/user-question/${infoEndpoint}/${identifier}/stress-and-fatigue/Phase 5`,
//         );

//         const stressCompleted = phaseStressRes.data.some(
//           (q) =>
//             q.questionIndex === 5 &&
//             q.phaseName === "Phase 5" &&
//             q.questionNumber === "Question 5_5",
//         );

//         setThemeCompleteStressFatigue(stressCompleted);
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadData();
//   }, [user, googleUser, apiUrl]);

//   if (loading) {
//     return <LoadingSpinner />;
//   }

//   return (
//     <>
//       <div id="relifeClassChild">
//         {theme.map((t) =>
//           t.id === 1 ? (
//             // <div>

//             <Link
//               to={`/session/${t.slug}`}
//               className={"linkTagTheme"}
//               key={t.id}
//               onClick={() => setRedirection(`/session/${t.slug}`)}
//             >
//               {themeCompleteLoveDisappointment ? (
//                 <p className="available" style={{ color: "green" }}>
//                   Completed
//                 </p>
//               ) : (
//                 <p className="available" style={{ color: "green" }}>
//                   Available
//                 </p>
//               )}

//               <img
//                 src={t.image}
//                 alt="1"
//                 width={200}
//                 height={200}
//                 className="cardImg"
//               />
//               <h2
//                 className="cardTitle"
//                 id="cardTitle1"
//                 style={{ fontSize: "1.7rem" }}
//               >
//                 {t.title}
//               </h2>
//               <p className="cardDesc">{t.description}</p>
//               <hr className="cardLine" />
//               <p className="cardDuration">
//                 Progress:{" "}
//                 {themeCompletion
//                   ? Math.floor((themeCompletion / 25) * 100) + "%"
//                   : "0%"}
//               </p>
//             </Link>
//           ) : t.id === 2 ? (
//             <Link
//               to={`/session/${t.slug}`}
//               className={"linkTagTheme"}
//               key={t.id}
//               onClick={() => setRedirection(`/session/${t.slug}`)}
//             >
//               {themeCompleteStressFatigue ? (
//                 <p className="available" style={{ color: "green" }}>
//                   Completed
//                 </p>
//               ) : (
//                 <p className="available" style={{ color: "green" }}>
//                   Available
//                 </p>
//               )}

//               <img
//                 src={t.image}
//                 alt="1"
//                 width={200}
//                 height={200}
//                 className="cardImg"
//               />
//               <h2
//                 className="cardTitle"
//                 id="cardTitle1"
//                 style={{ fontSize: "1.7rem" }}
//               >
//                 {t.title}
//               </h2>
//               <p className="cardDesc">{t.description}</p>
//               <hr className="cardLine" />
//               <p className="cardDuration">
//                 Progress:{" "}
//                 {themeCompletion1
//                   ? Math.floor((themeCompletion1 / 25) * 100) + "%"
//                   : "0%"}
//               </p>
//             </Link>
//           ) : (
//             <Link
//               className={"linkTagTheme disabledLinkTagTheme"}
//               disabled
//               key={t.id}
//               style={{ position: "relative" }}
//             >
//               <img src={t.image} alt="1" width={200} height={200} />
//               <h2
//                 className="cardTitle"
//                 id="cardTitle2"
//                 style={{ fontSize: "2rem" }}
//               >
//                 {t.title}
//               </h2>
//               <p>{t.description}</p>
//               <hr />
//               <p>COMING SOON</p>
//             </Link>
//           ),
//         )}
//       </div>
//     </>
//   );
// }
